import { useMemo, useState } from 'react';
import Select from 'react-select';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import { useSettings } from 'context/SettingsContext';
import { useTheme } from 'context/ThemeContext';
import { selectStylesDark, selectStylesLigth } from 'utils/helpers/structs/selectStyles';
import type { SelectOption } from '../types';

interface VendorSelectProps {
    value?: number | null;
    onChange: (option: SelectOption | null) => void;
    required?: boolean;
    /** Якщо не задано — залежить від доступу prodEdit */
    disabled?: boolean;
    isClearable?: boolean;
    placeholder?: string;
    className?: string;
    inputId?: string;
}

const VendorSelect = ({
    value,
    onChange,
    required = true,
    disabled,
    isClearable = false,
    placeholder,
    className = 'w-100',
    inputId,
}: VendorSelectProps) => {
    const { auth } = useAuth();
    const { darkTheme } = useTheme();
    const { localSettings } = useSettings();
    const [selectTheme] = useState(darkTheme ? selectStylesDark : selectStylesLigth);

    const options = useMemo<SelectOption[]>(
        () =>
            localSettings?.DIRS.Vendor?.filter(
                (vendor) => !vendor.hidden || vendor.ID === value,
            )?.map((vendor) => ({
                value: vendor.ID,
                label: vendor.vendorName,
            })) || [],
        [localSettings?.DIRS.Vendor, value],
    );

    const isDisabled =
        disabled !== undefined ? disabled : !hasUserAccess(auth?.user, 'prodEdit');

    return (
        <Select<SelectOption>
            inputId={inputId}
            options={options}
            required={required}
            isClearable={isClearable}
            placeholder={placeholder}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            menuPosition="fixed"
            styles={{
                ...selectTheme,
                control: (base, state) => ({
                    ...base,
                    ...(selectTheme.control ? selectTheme.control(base, state) : {}),
                }),
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 2000,
                }),
            }}
            className={className}
            value={options?.find((vendor) => vendor?.value == value) || null}
            onChange={onChange}
            isMulti={false}
            isDisabled={isDisabled}
        />
    );
};

export default VendorSelect;
